export default "__VITE_ASSET__CVJyEOs8__"